import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ContactsService } from '../contacts/contacts.service';
import { ToasterService } from '../common/toaster/toaster.service';

import { Title, Meta } from '@angular/platform-browser';
@Component({
  selector: 'app-contacts',
  templateUrl: './contacts.component.html',
  styleUrls: ['./contacts.component.css']
})
export class ContactsComponent implements OnInit {

  registerForm: FormGroup;
  email:any;
  message:any;
  successMsg = false;
  selectedid = '';
  selectedBtnId = '';
  submitted = false;

  constructor( private formBuilder: FormBuilder,private _contactsService: ContactsService,private toaster: ToasterService,private _router: Router,private titleService: Title, private metaService: Meta) { }

  ngOnInit() {
    this.registerForm = this.formBuilder.group({
      salutation: ['MR', Validators.required],
      firstName: ['', Validators.required],
      lastName: ['', Validators.required],
      email: ['', [Validators.required,Validators.email]],
      phone: [''],
      bookingnumber: [''],
      ask: ['', Validators.required]
  });

  this.titleService.setTitle('Contact l Ticketvoordeel.nl');
  this.metaService.addTags([
    {name: 'keywords', content:'Team Ticketvoordeel.nl, contact ticketvoordeel.nl, bellen ticketvoordeel.nl, email adres ticketvoordeel'},
    {name: 'description', content: 'Uw vertrouwde adres voor het boeken van voordelige vliegtickets. U spaart ook ‘Ticks’  bij Ticketvoordeel.nl die u later kunt inwisselen voor extra korting of mooie cadeaus. '},
    {name: 'robots', content: 'index, follow'}
  ]);
  }

  get f() { return this.registerForm.controls; }

  onSubmit() {
    this.submitted = true;
    // stop here if form is invalid
    if (this.registerForm.invalid) {
        return;
    } else {
      this._contactsService.sendContactRequest(this.registerForm.value).subscribe((response: any) => {
        if (response.body.status && response.body.message === 'success') {
           this.successMsg = !this.successMsg;
        } else {
          this.toaster.show('error', 'Message not sent');
           }
      });
    }
}


  showHideDiv(id, btnid) {
    const elementid = document.getElementById(id);
    const elementbtnid = document.getElementById(btnid);
    if (this.selectedBtnId !== '' && this.selectedid !== '') {
      const selectedid = document.getElementById(this.selectedid);
      const selectedbtnid = document.getElementById(this.selectedBtnId);
      selectedid.style.display = 'none';
      selectedbtnid.style.backgroundColor = '';
    }
    if (elementid.style.display === 'none' || elementid.style.display === '' ) {
      elementid.style.display = 'block';
      elementbtnid.style.backgroundColor = '#c62a82';
      this.selectedid = id;
      this.selectedBtnId = btnid;
    } else {
      elementid.style.display = 'none';
      elementbtnid.style.backgroundColor = '';
    }
  }


    // sendFaqMessage() {
    //   console.log(this.email, this.message)
    //   if (this.email != undefined && this.message != undefined) {
    //   this._contactsService.sendFaqRequest(this.email, this.message).subscribe((response: any) => {
    //     if (response.body.status && response.body.message === 'success') {
    //        this.successMsg = !this.successMsg;
    //     } else {
    //       this.toaster.show('error','Message not sent');
    //        }
    //   });
    // } else {
    //   this.toaster.show('error','Please fill all fields');
    // }
    // }

    redirectToFaq(){
      this._router.createUrlTree(['/faq']);
    }

}
